import { load } from 'recaptcha-v3'
import { getMeta } from 'lambda-dom'

export const recaptchaV3Key = getMeta('recaptcha-v3-key')

export const recaptchaReady = recaptchaV3Key
    ? load(recaptchaV3Key)
    : Promise.resolve(null)
